import React from 'react';
import { Heading } from '@nbirl/nbi-common-ui-libs';

type SidebarProps = {
  heading?: string;
  filterLinks?: React.ReactNode;
  action?: React.ReactNode;
};

export const Sidebar: React.FC<SidebarProps> = ({
  heading,
  filterLinks,
  action,
  children,
}) => (
  <div className="z-10 w-80 flex flex-col flex-shrink-0 bg-primary-25 shadow-right-dark-teal">
    {heading && (
      <Heading level={3} size="md" variant="teal" className="px-3 py-4">
        {heading}
      </Heading>
    )}

    {filterLinks && <>{filterLinks}</>}

    <div className="flex-1 overflow-auto">
      <div className="p-2 w-max">{children}</div>
    </div>

    {action && <div className="p-2 border-t border-gray-100">{action}</div>}
  </div>
);
